import React from "react";
import style from "./alumniLogoHeader.module.css";
import Image from "next/image";
import Link from "next/link";
const AlumniLogoHeader = () => {
  return (
    <div className={style.alumniHeader}>
      <Link href="/">
        <Image
          src="/assets/regLogo.png"
          alt="alumni-payment-success-icon"
          title="alumni-payment-success-icon"
          width={220}
          height={44}
        />
      </Link>
    </div>
  );
};

export default AlumniLogoHeader;
